export default {
    common: {
        title: "Modifier l'image",
        cancel: "Cnnuler",
        save: "Enregistrer",
        crop: "Recadrer",
        adjustments: "Les ajustements",
        filters: "Filtres",
        frames: "Verres ",
        overlays: "Superpositions",
        text: "Texte",
        stickers: "Autocollants",
        brush: "Brosse",
        ai: "Créer une image en utilisant l'intelligence artificielle",
        reset: "Réinitialiser",
        comingSoon: 'Prochainement...',
    },
};
